import styled from 'styled-components';
import colors from 'themes/Main';

const { darkBlue, gray01, gray03, gray06, white, blue } = colors;

export const Container = styled.div`
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 32px;
  right: 32px;
`;

export const FloatMenu = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: center;
  border-radius: 5px;
  min-width: 200px;
  padding: 16px 0;
  margin-bottom: 70px;
  background: ${white};
  box-shadow: 0px 4px 5px rgba(215, 220, 230, 0.2),
    0px 3px 14px rgba(215, 220, 230, 0.12),
    0px 8px 10px rgba(215, 220, 230, 0.14);

  p {
    cursor: context-menu;
    padding: 8px 16px 8px;
    color: ${gray03};
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    border-bottom: 1px solid ${gray06};
    margin-bottom: 0;
  }
`;

export const FloatMenuItem = styled.button`
  width: 100%;
  padding: 8px 16px;
  color: ${gray01};
  outline: none;
  border: none;
  background: ${white};
  transition: all 0.2s ease-in;

  &:not(:last-child) {
    border-bottom: 1px solid ${gray06};
  }

  &:hover {
    background: ${({ isDisabled }) => (isDisabled ? white : blue)};
    color: ${({ isDisabled }) => (isDisabled ? gray01 : white)};
  }

  &:active,
  &:focus {
    -moz-appearance: none;
    -webkit-appearance: none;
    outline: none;
  }
`;

export const FloatButton = styled.button`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  border-radius: 30px;
  background: ${({ isDisabled }) => (isDisabled ? gray06 : darkBlue)};
  box-shadow: ${({ isDisabled }) =>
    isDisabled
      ? '0 0 0 0'
      : '0px 4px 5px rgba(0, 131, 202, 0.2), 0px 3px 14px rgba(0, 131, 202, 0.12), 0px 8px 10px rgba(0, 131, 202, 0.14)'};
  transition: all 0.2s ease-in;

  &:hover {
    background: ${({ isDisabled }) =>
      isDisabled ? 'transparent' : 'rgba(0, 131, 202, .85)'};
  }

  &:active,
  &:focus {
    outline: none;
  }
`;

export const Icon = styled.svg`
  width: 25px;
  height: 25px;
  transform: ${({ isClicked }) =>
    isClicked ? 'rotate(0)' : 'rotate(-135deg)'};
  transition: all 0.2s ease-in;
`;

export const IconPath = styled.path`
  fill: ${gray06};
`;
